var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#4B57E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3495 13.3175C16.2257 13.3175 16.1253 13.4178 16.1253 13.5416V15.5317C16.1249 15.903 15.8241 16.2038 15.4529 16.2042H9.16368C8.79245 16.2038 8.49169 15.903 8.49125 15.5317V9.69081C8.49169 9.31966 8.79245 9.01882 9.16368 9.01838H11.1538C11.2776 9.01838 11.378 8.91805 11.378 8.79424C11.378 8.67053 11.2776 8.5701 11.1538 8.5701H9.16368C8.54501 8.5708 8.04367 9.07214 8.04297 9.69081V15.5318C8.04367 16.1505 8.54501 16.6518 9.16368 16.6525H15.4529C16.0716 16.6518 16.5729 16.1505 16.5736 15.5318V13.5416C16.5736 13.4178 16.4733 13.3175 16.3495 13.3175Z",
    fill: "#4B57E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4851 7.99543C16.0912 7.60152 15.4526 7.60152 15.0587 7.99543L11.0598 11.9943C11.0324 12.0217 11.0126 12.0557 11.0023 12.093L10.4764 13.9914C10.4548 14.0693 10.4768 14.1526 10.5339 14.2098C10.5911 14.2669 10.6744 14.2888 10.7522 14.2673L12.6507 13.7414C12.688 13.731 12.722 13.7112 12.7494 13.6838L16.7481 9.68491C17.1414 9.29073 17.1414 8.65263 16.7481 8.25845L16.4851 7.99543ZM11.5482 12.14L14.821 8.86714L15.8764 9.92262L12.6036 13.1955L11.5482 12.14ZM11.3374 12.563L12.1806 13.4064L11.0142 13.7295L11.3374 12.563ZM16.4312 9.36796L16.1935 9.60567L15.1379 8.5501L15.3757 8.31239C15.5945 8.09358 15.9493 8.09358 16.1681 8.31239L16.4312 8.5754C16.6496 8.79447 16.6496 9.14898 16.4312 9.36796Z",
    fill: "#4B57E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2ca0a66c672c725a765c60d95112389f.svg";
export { ForwardRef as ReactComponent };